export default "__VITE_ASSET__D6Gd4Sk4__"